<template>
  <div class="billing-system">
    <OrderItem
      v-for="item in orderList"
      :key="item.orderId"
      :orderItem="item"
    />
    <Empty v-if="!orderList.length" />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import OrderItem from '../components/OrderItem.vue';
import Empty from '../common/Empty.vue';
import { IOrderList } from '../billingSystem';
import { Route } from 'vue-router';
@Component({
  components: {
    OrderItem,
    Empty,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next(async (vm: BillingSystem) => {
      window.Al.start();
      window.np.start();
      await vm.getInvoiceOrders();
      window.Al.done();
      window.np.done();
    });
  },
})
export default class BillingSystem extends Vue {
  orderList: IOrderList[] = [];

  async getInvoiceOrders() {
    const { data } = await window.apis.getInvoiceOrders();
    this.orderList = data;
  }
}
</script>

<style lang="scss" scoped>
.billing-system {
  height: 100vh;
  padding: 24px 32px;
  overflow: auto;
  background-color: #f7f7fb;
}
</style>